{"enable":true,"dsn":"https://33533ffa323643b68f704d1be71dcd42@o51392.ingest.sentry.io/6395741","environment":"testing"}